import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import axios from "axios";
import VueRouter from 'vue-router';
import Qs from 'qs';

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import store from './store'


Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons)
Vue.use(axios);
Vue.use(VueRouter);

Vue.component('date-picker', require('./components/common/DatePicker').default);

Vue.config.productionTip = false;

const token = localStorage.getItem('token');
if (token) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
}

axios.defaults.paramsSerializer = function (params) {
  return Qs.stringify(params, { arrayFormat: 'brackets', encodeValuesOnly: true })
};

const routes = [
  {
    path: '/',
    component: () => import('./components/MainScreen'),
    children: [
      {
        path: '/shipment-accept',
        component: () => import('./components/shipment-accept/ShipmentAcceptScreen'),
      }, {
        path: '/returns',
        component: () => import('./components/returns/ReturnsScreen'),
      }, {
        path: '/registers',
        component: () => import('./components/registers/RegistersScreen'),
      }, {
        path: '/report',
        component: () => import('./components/report/ReportScreen'),
      }, {
        path: '/settings',
        component: () => import('./components/settings/SettingsScreen'),
      },
    ],
  }
];

const router = new VueRouter({
  routes: routes
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
